import { Component, OnInit, Inject, ViewChild, ViewEncapsulation, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { GlobalService } from '../service/global.service';
import { EventInfo } from '../model/event.model';
import { EventDocumentInfo } from '../model/eventdocument.model';
import { TokenService } from '../service/token.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,

  FormArray
} from '@angular/forms';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css']
})
export class EventComponent implements OnInit {
  /**************************** Variable ***************************** */
  @Input() ProjectId: string;
  @Input() ViewMode: boolean = false;
  baseurl: string

  titlemodal: string
  detailmodal: string
  modalDocName: string;
  modalDocInfo: any;

  // Variable Event Zone
  EventListPromise: Promise<EventInfo[]>
  EventList: EventInfo[]
  EventDetailList: EventInfo[]
  EventListPromisereturn: Promise<EventInfo[]>[]

  EventDocumentListPromise: Promise<EventDocumentInfo[]>
  EventDocumentList: EventDocumentInfo[] = [];
  EventDocumentListPromisereturn: Promise<EventDocumentInfo[]>[]

  txtSearchDate: string
  txtEventSubject: string
  txtEventStartDate: string
  txtEventStartTime: string
  txtEventEndDate: string
  txtEventEndTime: string
  hidEventId: number

  titleModal: string
  EventId: number

  // Zone pagination variable
  public currentEventPageNumber: number
  public LookupTotal: number
  public totalEventPages: number
  public environment: number

  isSubmitted: any;
  isEventUpdate: boolean;
  isEventSubmitted: any;
  isOnUpdate: boolean;
  getreturn: Promise<string>;
  // End Variable Event Zone

  //Base line document
  baselineFilesToUpload: File[];
  baselinePathFile: string = '';
  IsClearList: boolean = false;
  form: FormGroup;
  /**************************** End Variable ***************************** */


  /**************************** Structure Function *************************/
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    //GlobalService.CheckPagingAccessRights();
  }

  ngOnInit(): void {
    this.LoadEvent();
    this.LoadEventDocument(this.EventId);
    this.IsClearList = false;

    //Initial month control
    var d = new Date();
    this.txtSearchDate = d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2, '0');
    
    this.form = this.formBuilder.group({
      txtEventSubject: [null, Validators.required],
      txtEventStartDate: [null, Validators.required],
      txtEventEndDate: [null, Validators.required]
      });
    
  }
  /**************************** End Structure Function ****************** */


  /**************************** Functions ******************************* */
  LoadEventList(auth_token): Observable<EventInfo[]> {
   
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentEventPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EventProjectId'] = this.ProjectId;
      objectjson['Active'] = "Y";
      objectjson['StartDate'] = this.txtSearchDate;



      let strjson = JSON.stringify(objectjson);
      return this.httpClient
        .post<EventInfo[]>(this.baseurl + "Event/GetEvent",
          strjson, httpOptions)
    
  }

  LoadEventDetailList(EventId, auth_token): Observable<EventInfo[]> {
    
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentEventPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EventProjectId'] = this.ProjectId;
      objectjson['EventId'] = EventId;
      objectjson['Active'] = "Y";



      let strjson = JSON.stringify(objectjson);
      return this.httpClient
        .post<EventInfo[]>(this.baseurl + "Event/GetEvent",
          strjson, httpOptions)
    
  }

  LoadEventDocumentList(EventId, auth_token): Observable<EventDocumentInfo[]> {
   
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};


      objectjson['EventId'] = EventId;
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);
      return this.httpClient
        .post<EventDocumentInfo[]>(this.baseurl + "EventDocument/GetEventDocument",
          strjson, httpOptions)
    
  }

  public onDateChanged(event) {

    this.txtSearchDate = event.target.value;
    this.LoadEvent();
  }

  async LoadEvent() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadEventList(auth_token)
        .subscribe({
          next: data => {
            
            this.EventList = data;
          },
          error: error => {
            console.error('There was an error!', error);
          }
        })
    }
  }

  async LoadEventDetail(EventId) {
    if (!!EventId) {
      this.isOnUpdate = true
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadEventDetailList(EventId, auth_token)
          .subscribe({
            next: data => {
              this.EventDetailList = data;
              if (this.EventDetailList.length) {
                $('#modalEventControllerTitle').text('Edit Event');
                this.txtEventSubject = this.EventDetailList[0].Subject != null ? this.EventDetailList[0].Subject : null
                this.txtEventStartDate = this.EventDetailList[0].StartDate != null ? this.GlobalService.formatDate(this.EventDetailList[0].StartDate) : null
                this.txtEventStartTime = this.EventDetailList[0].StartDate != null ? this.GlobalService.formatTime(this.EventDetailList[0].StartDate) : null
                this.txtEventEndDate = this.EventDetailList[0].EndDate != null ? this.GlobalService.formatDate(this.EventDetailList[0].EndDate) : null
                this.txtEventEndTime = this.EventDetailList[0].EndDate != null ? this.GlobalService.formatTime(this.EventDetailList[0].EndDate) : null
                this.hidEventId = EventId;

                this.LoadEventDocument(EventId);
              }
            },
            error: error => {
              console.error('There was an error!', error);
            }
          })
      }
    }
  }

  async LoadEventDocument(EventId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadEventDocumentList(EventId, auth_token)
        .subscribe({
          next: data => {
            
            this.EventDocumentList = data;
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }

  btnClick_deleteEvent(id, auth_token): Observable<EventInfo[]> {
    
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['EventId'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<EventInfo[]>(this.baseurl + "Event/DeleteEvent", strjsonCusInfo, httpOptions);
    
  }


  async btnClick_deleteEventitem(id) {
    if (!id)
      id = this.hidEventId;

    if (confirm("Are you sure you want to delete this item ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteEvent(parseInt(id), auth_token).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              this.titlemodal = 'Delete Event done.';
              this.detailmodal = 'Your event was deleted successfully.';
              $('#modalEventController').modal('hide')
              $('#ModalComplate').modal();
              this.LoadEvent();
            }
          );
      }
    }

  }


  async btnClick_onDeleteEventList() {

    if (confirm("Are you sure you want to delete this event?")) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedEvent = $('[name="checkboxEvent"]:checked');

        let num = checkkedEvent.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var Eventcurrent = <HTMLInputElement>checkkedEvent[i];
          observableBatch.push(this.btnClick_deleteEvent(parseInt(Eventcurrent.value), auth_token).toPromise().then(val => {
          }));

        }

        Promise.all(observableBatch).then(val => {
          console.log('สำเร็จ');
          this.titlemodal = 'Delete event done.';
          this.detailmodal = 'Your event was deleted successfully.';

          $('#ModalComplate').modal();
          this.LoadEvent();
        });
      }

    }

  }

  async btnClick_submitInsertEvent() {
    if (this.form.valid) {
    this.OnCreating('y');
    
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      debugger
      var objJson = {};
      objJson["Subject"] = !!this.txtEventSubject ? this.txtEventSubject : "";
      objJson["EventProjectId"] = this.ProjectId;
      this.txtEventStartTime = !!this.txtEventStartTime ? this.txtEventStartTime : "00:00";
      this.txtEventEndTime = !!this.txtEventEndTime ? this.txtEventEndTime : "00:00";
      objJson["StartDate"] = !!this.txtEventStartDate && !!this.txtEventStartTime ? this.txtEventStartDate + "T" + this.txtEventStartTime + ":00" : "";
      objJson["EndDate"] = !!this.txtEventEndDate && !!this.txtEventEndTime ? this.txtEventEndDate + "T" + this.txtEventEndTime + ":00" : "";
      objJson["CreateBy"] = !!localStorage.getItem("EmpCode") ? localStorage.getItem("EmpCode") : "";
      objJson["Active"] = "Y";

      let strjson = JSON.stringify(objJson);

      this.isEventSubmitted = this.httpClient.post<EventInfo[]>(this.baseurl + "Event/InsertEvent", strjson, httpOptions)

        .subscribe(result => this.isEventSubmitted = result, failCb => {
          console.log("Insert fail")
          this.OnCreating('n');
          $('#ModalError').modal();
        },
          async () => {
            
            console.log("Insert = " + this.isEventSubmitted)
            if (this.baselineFilesToUpload.length > 0) {
              var isUploadSuccess = await this.UploadEventFilesToServer(this.baselineFilesToUpload);
              if (isUploadSuccess) {
                for (const val of this.baselineFilesToUpload) {
                  await this.InsertEventDocument(val.name, this.baselinePathFile + "\\" + val.name, this.isEventSubmitted)
                }
                this.OnCreating('n');
                this.IsClearList = true;
                await this.LoadEvent();
                $('#ModalCreateComplate').modal();
                $('#modalEventController').modal('hide')
              } else {
                this.OnCreating('y');
              }

            } else {
              this.OnCreating('n');
              await this.LoadEvent();
              $('#ModalCreateComplate').modal();
              $('#modalEventController').modal('hide')
            }
          }
        )
      }
    } else {
      this.GlobalService.validateAllFormFields(this.form);
      $('input.ng-invalid')[0].focus()
    }
  }

  async btnClick_submitUpdateEvent() {

    this.OnEditing('y');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objJson = {};
      objJson["Subject"] = !!this.txtEventSubject ? this.txtEventSubject : "";
      objJson["EventProjectId"] = this.ProjectId;
      objJson["StartDate"] = !!this.txtEventStartDate && !!this.txtEventStartTime ? this.txtEventStartDate + "T" + this.txtEventStartTime + ":00" : "";
      objJson["EndDate"] = !!this.txtEventEndDate && !!this.txtEventEndTime ? this.txtEventEndDate + "T" + this.txtEventEndTime + ":00" : "";
      objJson["CreateBy"] = !!localStorage.getItem("EmpCode") ? localStorage.getItem("EmpCode") : "";
      objJson["EventId"] = this.hidEventId;

      let strjson = JSON.stringify(objJson);

      this.isEventSubmitted = this.httpClient.post<EventInfo[]>(this.baseurl + "Event/UpdateEvent", strjson, httpOptions)

        .subscribe(result => this.isEventSubmitted = result, failCb => {
          console.log("Update fail")
          this.OnEditing('n');
        },
          async () => {

            console.log("Update = " + this.isEventSubmitted)
            if (!!this.baselineFilesToUpload) {

              var isUploadSuccess = await this.UploadEventFilesToServer(this.baselineFilesToUpload);
              if (isUploadSuccess) {
                for (const val of this.baselineFilesToUpload) {
                  await this.InsertEventDocument(val.name, this.baselinePathFile + "\\" + val.name, this.hidEventId)
                }

                this.OnEditing('n');
                this.IsClearList = true;
                await this.LoadEvent();
                $('#ModalUpdateComplate').modal();
                $('#modalEventController').modal('hide')
              } else {
                this.OnEditing('y');
              }

            } else {
              this.OnEditing('n');
              await this.LoadEvent();
              $('#ModalUpdateComplate').modal();
              $('#modalEventController').modal('hide')
            }
          }
        )
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  async InsertEventDocument(Filename, pathfile, eventid) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EventId'] = eventid;
      objectjson['EventDocumentFileName'] = Filename;
      objectjson['EventDocumentPathFile'] = pathfile;
      objectjson['FlagDelete'] = "N";
      objectjson['CreateBy'] = localStorage.getItem("EmpCode");

      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<EventDocumentInfo[]>(this.baseurl + "EventDocument/InsertEventDocument", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isSubmitted)
            this.LoadEventDocument(this.EventId);
          }
        )
    }
  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#txtEventSubject").prop('disabled', true);
      $("#txtEventStartDate").prop('disabled', true);
      $('#txtEventStartTime').prop('disabled', true);
      $('#txtEventEndDate').prop('disabled', true);
      $('#txtEventEndTime').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#txtEventSubject").removeAttr('disabled');
      $("#txtEventStartDate").removeAttr('disabled');
      $('#txtEventStartTime').removeAttr('disabled');
      $('#txtEventEndDate').removeAttr('disabled');
      $('#txtEventEndTime').removeAttr('disabled');
      $('#modalEventController').modal('hide');
    }

  }

  OnEditing(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#txtEventSubject").prop('disabled', true);
      $("#txtEventStartDate").prop('disabled', true);
      $('#txtEventStartTime').prop('disabled', true);
      $('#txtEventEndDate').prop('disabled', true);
      $('#txtEventEndTime').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#txtEventSubject").removeAttr('disabled');
      $("#txtEventStartDate").removeAttr('disabled');
      $('#txtEventStartTime').removeAttr('disabled');
      $('#txtEventEndDate').removeAttr('disabled');
      $('#txtEventEndTime').removeAttr('disabled');
      $('#modalEventController').modal('hide');
    }

  }

  OnClearEventControllerModal() {
    this.EventDocumentList = [];
    this.baselineFilesToUpload = [];
    $("#txtEventSubject").val('');
    $("#txtEventStartDate").val('');
    $('#txtEventStartTime').val('');
    $('#txtEventEndDate').val('');
    $('#txtEventEndTime').val('');
    $('#modalEventControllerTitle').text('Create New Event');
    this.isOnUpdate = false;

    this.IsClearList = false;
  }

  async UploadEventFilesToServer(files) {

    if (!files || files.length === 0) {
      alert("Please browse file at least one.")
      return false;
    }
    let filesToUpload: File[] = files;

    await Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.baselinePathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
            }

          } else if (event.type === HttpEventType.Response) {
          }
        });



    });

    return true;
  }

  DragFilesFinished(returnObj) {

    if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.baselineFilesToUpload = returnObj.Files;
      this.baselinePathFile = returnObj.PathFile;
    }
  }

  OnDeleteEventDocumentClick(elem) {
    let dataInfo = $(elem).parent().data();
    if (Object.keys(dataInfo).length > 0) {
      //Confirm to delete
      this.modalDocInfo = dataInfo;
      this.modalDocName = dataInfo.documentname;
      $('#ModalConfirmDeleteDoc').modal();
    }
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  async DeleteDocument() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentEventPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EventDocumentId'] = this.modalDocInfo.documentid;
      objectjson['EventId'] = this.modalDocInfo.eventid;

      let strjson = JSON.stringify(objectjson);
      this.httpClient
        .post<boolean>(this.baseurl + "EventDocument/DeleteEventDocument",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            if (data) {
              this.titlemodal = "Success";
              this.detailmodal = "The document has been deleted."
              $('#modalEventController').modal('hide');
              this.LoadEvent();
            } else {
              this.titlemodal = "Sorry";
              this.detailmodal = "Delete fail."
            }

            $('#ModalResult').modal();
          },
          error: error => {
            console.error('There was an error!', error);
          }
        })
    }
  }
}
